import React from 'react';
import ComingSoonIcon from '../components/template/icons/ComingSoonIcon';
import './ComingSoon.scss';

class ComingSoon extends React.Component {
  render() {
    return (
      <div className="coming-soon top-level">
        <h1 className="text">
          This page is coming soon; we're working on building out the Fides Investor platform.
        </h1>
        <ComingSoonIcon />
      </div>
    );
  }
}

export default ComingSoon;
